import ContactNewPage from '../../components/pages/contacts/ContactNewPage.vue'

export default {
  components: { ContactNewPage }
}
